import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'gotham-pro-font/fonts.min.css'
import 'swiper/swiper-bundle.css'
import '@mdi/font/css/materialdesignicons.css'
import '@/assets/fonts/font-awesome/css/all.min.css'
import '@/assets/fonts/font-awesome/css/light.min.css'
import '@/assets/fonts/font-awesome/css/duotone.min.css'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  }
})
